
import Vue, { PropType } from 'vue';

import ErrorFilled from '@carbon/icons-vue/es/error--filled/20';
import CheckmarkFilled from '@carbon/icons-vue/es/checkmark--filled/20';
import WarningFilled from '@carbon/icons-vue/es/warning--filled/20';
import { PipelineNotificationType } from '../typings/PipelineNotificationType';
import { validatorTypes, ValidatorValueType } from '@/constants/validatorTypes';
import { mapState } from 'pinia';
import { useStore as useProductStore } from '@/stores/product';

export default Vue.extend({
  name: 'BellNotification',
  components: {
    ErrorFilled,
    CheckmarkFilled,
    WarningFilled,
  },
  props: {
    data: {
      type: Object as PropType<PipelineNotificationType>,
    },
  },
  computed: {
    ...mapState(useProductStore, [
      'printPositions',
      'unavailablePrintPositions',
    ]),
    type(): ValidatorValueType {
      return ((dict) => {
        return (
          dict[this.data.validatorName as keyof typeof dict] ||
          this.data.validatorName
        );
      })({
        fileTypeValidator: validatorTypes.fileTypeValidator,
        resolutionValidator: validatorTypes.resolutionValidator,
        spotColorsValidator: validatorTypes.spotColorsValidator,
        maxNumberOfColoursValidator: validatorTypes.maxNumberOfColoursValidator,
        outOfBoundaries: validatorTypes.collisionDetection,
        smallDetails: validatorTypes.smallDetails,
        commercialRemark: validatorTypes.commercialRemark,
      });
    },
    outcome(): number {
      if (this.data.validatorColor === 'Green') {
        return 0;
      }
      if (this.data.validatorColor === 'Red') {
        return 1;
      }
      return 2;
    },
  },
  methods: {
    maxNumberOfColours(positionId: string): number {
      const position = this.printPositions.find((p) => p.id === positionId);
      const positionModel = this.unavailablePrintPositions.find(
        (p) => p.positionId === positionId
      );
      const maxNumOfColors = position?.printTechniques.find((technique) => {
        return technique.id === positionModel?.technique.id;
      })?.maximumColours;
      return maxNumOfColors as number;
    },
  },
});
